import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './src/ui/__generated__/InlineCreateAdditionalFieldsEntrypointQuery$parameters';

type EntryPointParams = {
	cloudId: string;
	projectKey: string | null;
	defaultAssigneeId?: string;
};

export const InlineCreateAdditionalFieldsEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-inline-create-additional-fields" */ './src/ui/InlineCreateAdditionalFieldsEntrypoint'
			),
	),
	getPreloadProps: ({ cloudId, projectKey, defaultAssigneeId }: EntryPointParams) =>
		({
			queries: {
				rootData: {
					parameters,
					variables: {
						cloudId,
						projectKey: projectKey ?? '',
						hasProjectKey: !!projectKey,
						defaultAssigneeId: defaultAssigneeId ?? '',
						hasDefaultAssignee: !!defaultAssigneeId,
					},
				},
			},
		}) as const,
});
